import getCarJellyFromExtColors from './getCarJellyFromExtColors';
import getSeriesV1UniqueSeries from './getSeriesV1UniqueSeries';

export default { getCarJellyFromExtColors, getSeriesV1UniqueSeries };
